import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const loading = (state = initialState.loading, action) => {
  switch (action.type) {
    case types.TOGGLE_LOADER:
      return action.loading;

    default:
      return state;
  }
};
